import { useTranslation } from 'react-i18next';
import eateliersLogo from '../../assets/images/eateliers-logo.svg';
import { sanitizeMaintenanceHtml } from '../../utils/maintenanceHtmlSanitize';

interface MaintenancePageProps {
  content: string;
}

const hasVisibleText = (html: string): boolean => {
  if (!html) return false;
  const temp = document.createElement('div');
  temp.innerHTML = html;
  return (temp.textContent?.trim().length ?? 0) > 0;
};

const MaintenancePage = ({ content }: MaintenancePageProps) => {
  const { t } = useTranslation();
  const sanitized = sanitizeMaintenanceHtml(content);
  const showFallback = !hasVisibleText(sanitized);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-lg w-full">
        <img
          src={eateliersLogo}
          alt="eAteliers"
          className="h-20 w-auto mx-auto mb-6"
        />
        {showFallback ? (
          <div className="text-left">
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              {t('maintenance.fallback_title')}
            </h1>
            <p className="text-gray-600">{t('maintenance.fallback_body')}</p>
          </div>
        ) : (
          <div
            className="prose prose-gray max-w-none text-left"
            dangerouslySetInnerHTML={{ __html: sanitized }}
          />
        )}
      </div>
    </div>
  );
};

export default MaintenancePage;
